import { render } from "./fileView.vue?vue&type=template&id=dcec5fa4"
import script from "./fileView.vue?vue&type=script&lang=js"
export * from "./fileView.vue?vue&type=script&lang=js"

import exportComponent from "/home/adachi/omega-base/omega/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__